import _ from 'lodash';
import React, { Component } from 'react';
import { Form, Icon, Message } from 'semantic-ui-react';

import { validateEmail } from '../../helpers/utils';

// import { login } from '../../fetcher';
// import { UserContext } from '../../context';
// import { FORGET_FORM } from '../../helpers/constant';

class ForgetForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formStatus: false,
			formValue: {},
			data: {email: "bayuoscar.bo@gmail.com" },
			success: false
		}

		this.handleSubmit = this.handleSubmit.bind(this)
		this.handleChange = this.handleChange.bind(this)
	}

	handleChange(e, props){
		const { formValue } = this.state
			const { name, value } = props;
			this.setState({formStatus: false});
			return this.setState({formValue: _.assign({}, formValue, { [name]: value })});
	}

	handleSubmit(){
		const { formValue, data } = this.state
		
		const check = _.isEqual(data, formValue)
		if(check){
			return this.setState({formStatus: false, success: true});
		} else {
			return this.setState({formStatus: true });
		}
	}
	
	render() {
		const { formValue, formStatus, success } = this.state
		const { setStatus } = this.props
		const email = _.get(formValue, "email", "")
		const disabledButton = !validateEmail(email)
		return (
			<Form>
				<Form.Field>
					{!success && <span style={{color: "black"}}>Masukan alamat surel Anda dan kami mengirimkan pranala bantuan untuk menyetel ulang password Anda</span>}
					{success && <span style={{color: "black"}}>Surel reset password sudah kami kirim. Cek di kotak masuk surel kamu!</span>}
				</Form.Field>
				{!success && <Form.Field required>
					<label className="teal">Alamat Surel/ Email</label>
					<Form.Input name="email" placeholder='Masukan username/ nama unik Anda' value={email} onChange={this.handleChange}/>
				</Form.Field>}
				{formStatus && <div style={{marginBottom: "1em"}}>
					<Message negative size='tiny' header='Email tidak ditemukan'>
					<Message.Content>Untuk mengetahui surel terdaftar, silakan hubungi Tim Kami di <span><a href="https://wa.me/6281228800048">081228800048</a></span> via WhatsApp atau SMS</Message.Content>
				</Message></div>}
				<div style={{display: "flex", justifyContent: "space-between"}}>
					<Form.Button style={{margin: 0}} color="teal" basic floated="right" onClick={() => setStatus("LOGIN")}><Icon name="arrow left" /> Coba Login Lagi</Form.Button>
					{!success && <Form.Button color="teal" type="submit" floated="right" disabled={disabledButton} onClick={this.handleSubmit}>Kirim</Form.Button>}
				</div>
			</Form>
		);
	};
};

export default ForgetForm;